import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledContactsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  width: 100%;
  padding: 0 20px;
`;

export const StyledContactItem = styled.div`
  border-bottom: 0.5px solid ${colors.lightBlueGray};
  padding-bottom: 17px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: contain;
    margin-left: 15px;
  }

  .contact-info {
    .contact-name {
      font-size: 16px;
      line-height: 14px;
      letter-spacing: -0.29px;
      color: ${colors.darkBlue};
      margin-bottom: 8px;
    }
    .contact-phone {
      font-size: 12px;
      line-height: 14px;
      letter-spacing: -0.29px;
      color: ${colors.blueGray};
      text-decoration: none;
      cursor: pointer;
      transition: color 0.2s ease;

      &:hover {
        color: ${colors.darkBlue};
      }

      &:active {
        color: ${colors.blueGray};
      }
    }
  }

  .contact-date {
    margin-right: auto;

    .contact-source {
      padding: 0px 9px;
      border-radius: 100px;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: -0.29px;
      color: ${colors.darkBlue};
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
      font-weight: 500;
    }

    .contact-join-date {
      font-size: 12px;
      line-height: 14px;
      letter-spacing: -0.29px;
      color: ${colors.blueGray};
      text-align: end;
      padding-left: 5px;
    }
  }
`;

export const StyledEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  direction: rtl;

  .empty-icon {
    font-size: 64px;
    margin-bottom: 20px;
    opacity: 0.6;
  }

  .empty-title {
    font-size: 24px;
    font-weight: 600;
    color: ${colors.darkBlue};
    font-family: "Noto Sans Hebrew", sans-serif;
    margin-bottom: 12px;
  }

  .empty-subtitle {
    font-size: 16px;
    color: ${colors.blueGray};
    font-family: "Noto Sans Hebrew", sans-serif;
    line-height: 1.5;
    max-width: 300px;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    .empty-icon {
      font-size: 48px;
      margin-bottom: 16px;
    }

    .empty-title {
      font-size: 20px;
      margin-bottom: 8px;
    }

    .empty-subtitle {
      font-size: 14px;
    }
  }
`;
